/*
  Keeps the "--- Gift Boxes ---" block in the cart note in sync with the gift box line items
  (items with a "For" property). Runs after the PDP gift box is added, and whenever the cart
  changes in the drawer or on /cart, so removing a gift box also removes its note line.
*/
(function () {
  const NOTE_START = '--- Gift Boxes ---';
  const NOTE_END = '--- End Gift Boxes ---';

  function buildGiftBoxBlockFromCart(cart) {
    const lines = [];
    (cart.items || []).forEach((item) => {
      const props = item.properties || {};
      if (props.For) {
        lines.push(`Gift box: ${props.For}${item.quantity > 1 ? ` (x${item.quantity})` : ''}`);
      }
    });

    // No gift boxes -> empty block (the marked section gets removed)
    if (!lines.length) return '';

    return `${NOTE_START}\n${lines.join('\n')}\n${NOTE_END}`;
  }

  function upsertMarkedBlock(existingNote, newBlock) {
    const note = (existingNote || '').trim();

    const startIdx = note.indexOf(NOTE_START);
    const endIdx = note.indexOf(NOTE_END);

    // If no new block (no gift boxes), remove existing marked block if present
    if (!newBlock) {
      if (startIdx === -1 || endIdx === -1) return note;
      const afterEnd = endIdx + NOTE_END.length;
      const before = note.slice(0, startIdx).trim();
      const after = note.slice(afterEnd).trim();
      return [before, after].filter(Boolean).join('\n\n').trim();
    }

    // If markers exist, replace the whole marked section
    if (startIdx !== -1 && endIdx !== -1 && endIdx > startIdx) {
      const afterEnd = endIdx + NOTE_END.length;
      const before = note.slice(0, startIdx).trim();
      const after = note.slice(afterEnd).trim();
      return [before, newBlock, after].filter(Boolean).join('\n\n').trim();
    }

    // No markers yet -> append block
    return [note, newBlock].filter(Boolean).join('\n\n').trim();
  }

  // Update the note from a cart object; only writes when the note actually changes
  function syncFromCart(cart) {
    const currentNote = (cart.note || '').trim();
    const nextNote = upsertMarkedBlock(currentNote, buildGiftBoxBlockFromCart(cart));
    if (nextNote === currentNote) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: nextNote }),
    });
  }

  function sync() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      .then(syncFromCart)
      .catch((err) => console.error('[GiftBox] Note sync error:', err));
  }

  window.AEGiftBoxNote = { sync, syncFromCart };

  // Drawer / cart page quantity changes and removals (cart.js publishes the updated cart)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || event.source === 'product-form') return; // the PDP gift box script syncs after its own add
      const cart = event.cartData;
      if (cart && Array.isArray(cart.items) && 'note' in cart) {
        syncFromCart(cart).catch((err) => console.error('[GiftBox] Note sync error:', err));
      } else {
        sync();
      }
    });
  }

  // Catch gift boxes removed elsewhere (another tab, a full page reload) — only when the note has a block
  if (window.AE_GIFTBOX_NOTE_CHECK) sync();
})();
